import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'office-ui-fabric-react/lib/List';
import clsx from 'clsx';
import styles from './FinancialTableBody.style';
import FinancialTableRowContainer from '../FinancialTableRowContainer';

const renderTableRow = collapsibleSubLineItems => item =>
  <FinancialTableRowContainer item={item} collapsibleSubLineItems={collapsibleSubLineItems} />;

const FinancialTableBody = ({ items, className, collapsibleSubLineItems, ...other }) => (
  <List
    items={items}
    onRenderCell={renderTableRow(collapsibleSubLineItems)}
    className={clsx(className, styles.root)}
    {...other}
  />
);

FinancialTableBody.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      currency: PropTypes.string,
      returnsCap: PropTypes.number,
      capLimit: PropTypes.number,
      actualReturns: PropTypes.number,
      returnsOverCap: PropTypes.number,
      returnsIncluded: PropTypes.number,
      purchasedUnits: PropTypes.number,
      isPerCap: PropTypes.bool,
      parenthesizeDetails: PropTypes.bool,
      parenthesizeIfNegative: PropTypes.bool,
      href: PropTypes.string,
      bold: PropTypes.bool,
      details: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          amount: PropTypes.number.isRequired,
          returnsCap: PropTypes.number,
          capLimit: PropTypes.number,
          actualReturns: PropTypes.number,
          returnsOverCap: PropTypes.number,
          returnsIncluded: PropTypes.number,
          href: PropTypes.string,
          bold: PropTypes.bool,
        }),
      ),
    }),
  ),
  collapsibleSubLineItems: PropTypes.bool,
  className: PropTypes.string,
};

FinancialTableBody.defaultProps = {
  items: [],
  collapsibleSubLineItems: false,
  className: '',
};

export default FinancialTableBody;
